import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import ComingSoon from "@/pages/ComingSoon";

const OPEN_PATHS = ["/login", "/forgot-password", "/reset-password", "/choose-role"];
const LS = "htb_preview_code";

export default function SiteGate({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const fromUrl = new URLSearchParams(window.location.search).get("anteprima");
    const code = fromUrl || localStorage.getItem(LS) || "";
    api.get("/site/status", { params: { code } })
      .then(({ data }) => {
        if (data.preview_ok) localStorage.setItem(LS, code);
        else localStorage.removeItem(LS);
        setStatus(data);
      })
      .catch(() => setStatus({ maintenance: false }));
  }, []);

  if (!status || user === null) return <div className="min-h-screen bg-white" data-testid="site-gate-loading" />;
  const open = !status.maintenance || status.preview_ok || user || OPEN_PATHS.includes(location.pathname);
  return open ? children : <ComingSoon />;
}
